<div class="year-dialog-container">
    <h2 mat-dialog-title class="dialog-title">Select Financial Year</h2>

    <mat-dialog-content class="dialog-content" style="margin-top: 40px;">
        <mat-form-field appearance="fill" class="full-width">
            <mat-label style="color: grey;">Financial Year</mat-label>
            <mat-select [(value)]="selectedYear">
                <mat-option *ngFor="let year of financialYears" [value]="year">
                    {{ year }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </mat-dialog-content>

    <mat-dialog-actions align="end" class="dialog-actions" style="margin-bottom: -34px;">
        <button mat-stroked-button color="primary" (click)="cancel()">Cancel</button>
        <button mat-stroked-button style="background-color: red; color: white;" (click)="selectYear()">
            OK
        </button>
    </mat-dialog-actions>

    <div class="mt-5">
        <a class="pt-0 d-flex justify-content-center"
            style="display: flex; justify-content: center; align-items: center;">

            <img src="./assets/img/brand/red.png" class="navbar-brand-img" alt="..."
                style="height: 200px; width: auto;">
        </a>
    </div>

</div>